export const mockData = [
  {
    _index: '2023-06-23_ironstaging2_entity',
    id: '92a95053d925720a5e22279da54e33df0266e53e6d4e1dfddb55a1ec0eee42b6',
    attrs: {
      company_id: 7353,
      company_name: 'Culp',
      new_eid: '92a95053d925720a5e22279da54e33df0266e53e6d4e1dfddb55a1ec0eee42b5',
      subject: 'This is a case to check how it will look when the data presented is pretty long',
      sender_address: 'veryLongEmailCaseToCheckWhatHappens@pnfp.com',
      sender_name: 'motke@pnfp.com',
      first_reporter: 'Malware & URL Protection',
      recipient_address: 'Shahar@culp.com',
      recipient_name: 'Shahar',
      classification: 'Phishing',
      incident_type: 'Email',
      vip: false,
      message_id: '<1681741068.535.1687539486104.JavaMail.pps@m0167169.ppops.net>',
      office365_message_id: 'AAkALgAAAAAAHYQDEapmEc2byACqAC-EWg0AcEVmGUPFxUmJLmbKpJDvvgADnUMMwwAA',
      eid: '3b9b9853e2ff2b51621477a718223df8',
      email_arrival_time: '2023-06-23T16:58:08',
      updated_date: '2023-08-03T15:47:31',
      current_incident_id: 23853183,
      last_sender_risk_level: 'low',
      logs: [
        {
          silent_mode: true,
          is_scanback_report: true,
          initiated_by: 'Malware & URL Protection',
          date: '2023-08-03T12:47:31',
          log_type: 'microsoft_quarantine',
          sender_risk_level: 'low',
          themis_confidence: 0.52,
          themis_state: 'Safe',
          action_taken: 'No action',
          incident_id: 23853183,
          visible: true,
          phish: {},
        },
      ],
    },
  },
  {
    index: '2024-04-27_entity',
    attrs: {
      company_id: 1,
      company_name: 'IRONSCALES',
      new_eid: 'ce9b6fc9405e8af3e23a31ab386718647f170debd653cb7ae5c6b0399475b900',
      subject: 'Re: CompTIA Community-Introduction',
      sender_address: 'cjohnson@comptia.org',
      sender_name: 'Chris Johnson',
      recipient_address: 'wbuda@ironscales.com',
      recipient_name: 'William Buda',
      first_reporter: 'Impersonation Protection',
      current_anomaly: 'First Time Sender',
      incident_type: 'Email',
      links: true,
      attachments: true,
      email_attachments_list: [
        { attachment_name: 'image001.png', attachment_type: 'image/png' },
        { attachment_name: 'image002.png', attachment_type: 'image/pdf' },
        { attachment_name: 'image004.png', attachment_type: 'PDF' },
      ],
      links_list: [
        'https://calendly.com/mcookcomptia',
        'https://calendly.com/christopherdjohnson',
        'https://connect.comptia.org/',
        'http://www.tsp-isao.org/',
        'https://calendly.com/cmarquez_ironscales',
        'https://www.linkedin.com/company/ironscales',
        'https://twitter.com/IRONSCALES?s=20',
        'https://www.facebook.com/ironscalesltd/',
        'https://www.youtube.com/channel/UCz14RKHtm4sKmfz8-Nw6A1A',
        'https://4fb516e0ad974eb7b7d929125dbdc1ff.svc.dynamics.com/t/t/fq2Q2Xlyg7qH2ietTqKRZsH1w7IEdvHHxVWfTkLZhrkx/IcB8RITCfF2kCPxhRr04v6LLdKJIjwruxZSj4hPq6KQx',
        'https://4fb516e0ad974eb7b7d929125dbdc1ff.svc.dynamics.com/t/t/A4wrA8Mob2PYitxrNXMofiozDTCFticDmafSx8cPc9sx/IcB8RITCfF2kCPxhRr04v6LLdKJIjwruxZSj4hPq6KQx',
        'https://connect.comptia.org/channelcon/register-and-plan/register',
      ],
      vip: false,
      message_id:
        '<SN6PR07MB444611CE9CB04867D7BD2BB4D1152@SN6PR07MB4446.namprd07.prod.outlook.com>',
      office365_message_id: 'AAkALgAAAAAAHYQDEapmEc2byACqAC-EWg0AiVvpvSA97kK4oUc1rcw4eQACCg19xAAA',
      eid: '6d470939335179479148352170349d2e',
      email_arrival_time: '2024-04-27T21:19:15Z',
      updated_date: '2024-04-27T21:19:19',
      last_sender_risk_level: 'high',
      logs: [
        {
          date: '2024-04-27T21:19:19Z',
          sender_risk_level: 'high',
          anomaly: 'First Time Sender',
          initiated_by: 'Impersonation Protection',
          action_taken: 'Add banner',
          is_original_report: true,
          log_type: 'Suspicious email detected',
          is_scanback_report: false,
          silent_mode: false,
          visible: true,
        },
      ],
      create_incident_enabled: true,
    },
    id: 'idForNoamTest',
  },
  {
    _index: '2023-07-31_ironstaging2_entity',
    id: '61a9f7bb4e520a361d2ebf678beb746956e980be6560618f0ecdc6f5977cbd27',
    attrs: {
      company_id: 2359,
      company_name: 'IRONSDEV',
      new_eid: '61a9f7bb4e520a361d2ebf678beb746956e980be6560618f0ecdc6f5977cbd27',
      subject: 'sadasdsadsad',
      sender_address: 'meronelks@gmail.com',
      sender_name: 'מירון אלקבץ',
      recipient_address: 'merontwo@ironsdev.onmicrosoft.com',
      recipient_name: 'Meron Elk',
      first_reporter: 'End User',
      incident_type: 'Email',
      message_id: '<CAE0GCeuz73wMirN0SLXnHMuKO2bHCAONScVgzpYna-YMjLMsZw@mail.gmail.com>',
      office365_message_id:
        'AQMkADJmNWFiZjI1LTIxOTEtNDc4YS1iNzJiLWRmZgAwZTE1MGU3ZTEARgAAA-FlaRFmByhPvChBFqmT7NEHAHsLor_7AKRHsrb027NzLN4AAAIBDAAAAHsLor_7AKRHsrb027NzLN4AAAIFWAAAAA==',
      eid: 'cc47c9ccc7c3e52c71ad19988b5367e2',
      email_arrival_time: '2023-07-31T08:15:37',
      updated_date: '2023-07-31T12:23:50',
      current_incident_id: 23955536,
      last_sender_risk_level: 'high',
      logs: [
        {
          initiated_by: 'End User',
          date: '2023-07-31T09:23:50',
          log_type: 'Suspicious email reported',
          sender_risk_level: 'high',
          themis_state: 'Phishing',
          report_method: 'Reporting button',
          action_taken: 'No action',
          incident_id: 23955536,
          is_original_report: true,
          visible: true,
        },
      ],
    },
  },
  {
    _index: '2023-07-12_ironstaging14_entity',
    id: 'a077fea768f2340ada324439a9bf0e12e780d1643e813f95227918b5e807039f',
    attrs: {
      company_id: 2359,
      company_name: 'IRONSDEV',
      subject: 'IRONSCALES - Daily Threat Protection Report',
      sender_address: 'alerts@ironscales.com',
      sender_name: 'alerts@ironscales.com',
      recipient_address: 'moshe@ironsdev.onmicrosoft.com',
      recipient_name: 'Moshe Naot',
      incident_type: 'Email',
      links: true,
      message_id: '<168913894329.36176.11374963506224805994@ironscales.com>',
      office365_message_id: 'AAkALgAAAAAAHYQDEapmEc2byACqAC-EWg0AH_b_x-Z17U6TBaPnqKl_hAAAd9OdBwAA',
      eid: '0bc299c53fd505daac53c642f5971510',
      new_eid: 'a077fea768f2340ada324439a9bf0e12e780d1643e813f95227918b5e807039f',
      email_arrival_time: '2023-07-12T05:15:50',
      updated_date: '2023-07-12T08:15:53',
      last_sender_risk_level: 'low',
      email_attachments_list: [
        { attachment_name: 'image001.png', attachment_type: 'image/png' },
        { attachment_name: 'image002.png', attachment_type: 'image/pdf' },
        { attachment_name: 'image004.png', attachment_type: 'PDF' },
      ],
      links_list: [
        'https://calendly.com/mcookcomptia',
        'https://calendly.com/christopherdjohnson',
        'https://connect.comptia.org/',
        'http://www.tsp-isao.org/',
        'https://calendly.com/cmarquez_ironscales',
        'https://www.linkedin.com/company/ironscales',
        'https://twitter.com/IRONSCALES?s=20',
        'https://www.facebook.com/ironscalesltd/',
        'https://www.youtube.com/channel/UCz14RKHtm4sKmfz8-Nw6A1A',
        'https://4fb516e0ad974eb7b7d929125dbdc1ff.svc.dynamics.com/t/t/fq2Q2Xlyg7qH2ietTqKRZsH1w7IEdvHHxVWfTkLZhrkx/IcB8RITCfF2kCPxhRr04v6LLdKJIjwruxZSj4hPq6KQx',
        'https://4fb516e0ad974eb7b7d929125dbdc1ff.svc.dynamics.com/t/t/A4wrA8Mob2PYitxrNXMofiozDTCFticDmafSx8cPc9sx/IcB8RITCfF2kCPxhRr04v6LLdKJIjwruxZSj4hPq6KQx',
        'https://connect.comptia.org/channelcon/register-and-plan/register',
      ],
      logs: [
        {
          date: '2023-07-12T05:15:53',
          log_type: 'Presumed Safe',
          sender_risk_level: 'low',
          anomaly: 'Presumed safe',
          action_taken: 'No action',
          is_original_report: true,
          visible: true,
        },
      ],
    },
  },
  {
    _index: '2023-07-12_ironstaging14_entity',
    id: 'f04756d5cbbcdd104e57d54d5dd02623b6d0b6a13fee105b5574aff2f58676d3',
    attrs: {
      company_id: 2359,
      company_name: 'IRONSDEV',
      subject: 'IRONSCALES - Daily Threat Protection Report',
      sender_address: 'alerts@ironscales.com',
      sender_name: 'alerts@ironscales.com',
      recipient_address: 'Hila@ironsdev.onmicrosoft.com',
      recipient_name: 'הילה נתנזון',
      incident_type: 'Email',
      links: true,
      message_id: '<168913890058.1575.11073551053440378098@ironscales.com>',
      office365_message_id: 'AAkALgAAAAAAHYQDEapmEc2byACqAC-EWg0AjJCdG1enCEuvv7ru_qWt-gADrQdmKAAA',
      eid: '4f14f173e54b6112a1dfa538284964b7',
      new_eid: 'f04756d5cbbcdd104e57d54d5dd02623b6d0b6a13fee105b5574aff2f58676d3',
      email_arrival_time: '2023-07-12T05:15:03',
      updated_date: '2023-07-12T08:15:08',
      last_sender_risk_level: 'low',
      logs: [
        {
          date: '2023-07-12T05:15:08',
          log_type: 'Presumed Safe',
          sender_risk_level: 'low',
          anomaly: 'Presumed safe',
          action_taken: 'No action',
          is_original_report: true,
          visible: true,
        },
      ],
    },
  },
  {
    _index: '2023-05-11_ironstaging14_entity',
    id: 'e3df06e6b9a4781f6112872eb4baebe3ab6bd208ccff20581a393a3d9634d064',
    attrs: {
      company_id: 2359,
      company_name: 'IRONSDEV',
      subject: 'Receipt for Your Payment',
      sender_address: 'paypl@onlinepurchases.info',
      sender_name: 'Paypl',
      recipient_address: 'oleksandr@ironsdev.onmicrosoft.com',
      recipient_name: 'Oleksandr Chernihov',
      incident_type: 'Email',
      links: true,
      attachments: true,
      message_id: '<168380064027.16292.17574138043587585811@onlinepurchases.info>',
      office365_message_id: 'AAkALgAAAAAAHYQDEapmEc2byACqAC-EWg0AaDggcS4MW0elI6BIe-KHPQABKqAc3AAA',
      eid: '0faab45956ff7f0d656858f8b475aa3d',
      new_eid: 'e3df06e6b9a4781f6112872eb4baebe3ab6bd208ccff20581a393a3d9634d064',
      email_arrival_time: '2023-05-11T10:24:05',
      updated_date: '2023-07-11T16:22:43',
      current_incident_id: 21174904,
      last_sender_risk_level: 'high',
      logs: [
        {
          date: '2023-07-11T13:22:43',
          log_type: 'Reclassified as Spam',
          sender_risk_level: 'high',
          themis_confidence: 0.9,
          themis_state: 'Phishing',
          reported_by: 'Similarity Logic',
          action_taken: 'Move to spam',
          incident_id: 21174904,
          visible: true,
        },
      ],
    },
  },
  {
    _index: '2023-05-11_ironstaging14_entity',
    id: 'a9257a86823fb171148ce345a4001bcd4c876f8b0a90b015714caecd3a18318f',
    attrs: {
      company_id: 2359,
      company_name: 'IRONSDEV',
      subject: 'Receipt for Your Payment',
      sender_address: 'paypl@onlinepurchases.info',
      sender_name: 'Paypl',
      recipient_address: 'oleksandr@ironsdev.onmicrosoft.com',
      recipient_name: 'Oleksandr Chernihov',
      incident_type: 'Email',
      links: true,
      attachments: true,
      message_id: '<168380022038.16292.12054767779957889371@onlinepurchases.info>',
      office365_message_id: 'AAkALgAAAAAAHYQDEapmEc2byACqAC-EWg0AaDggcS4MW0elI6BIe-KHPQABKqAU8QAA',
      eid: '16e6207072351537c776f377c3d1b49b',
      new_eid: 'a9257a86823fb171148ce345a4001bcd4c876f8b0a90b015714caecd3a18318f',
      email_arrival_time: '2023-05-11T10:17:04',
      updated_date: '2023-07-11T16:22:43',
      current_incident_id: 21174904,
      last_sender_risk_level: 'high',
      logs: [
        {
          date: '2023-07-11T13:22:43',
          log_type: 'Reclassified as Spam',
          sender_risk_level: 'high',
          themis_confidence: 0.9,
          themis_state: 'Phishing',
          reported_by: 'IRONSCALES Community',
          action_taken: 'Move to spam',
          incident_id: 21174904,
          visible: true,
        },
      ],
    },
  },
  {
    _index: '2023-05-11_ironstaging14_entity',
    id: '6ab8ba4103977f610ca93ee60cafbcbd1a66edd277729c154ffac8f5dd768b7d',
    attrs: {
      company_id: 2359,
      company_name: 'IRONSDEV',
      subject: 'GOOGIE ANNIVERSARY WINNING NOTIFICATION',
      sender_address: 'donotreply@it-notif.com',
      sender_name: 'Googie Inc.',
      recipient_address: 'oleksandr@ironsdev.onmicrosoft.com',
      recipient_name: 'Oleksandr Chernihov',
      incident_type: 'Email',
      links: true,
      message_id: '<168380321306.16476.7479108644213037572@it-notif.com>',
      office365_message_id: 'AAkALgAAAAAAHYQDEapmEc2byACqAC-EWg0AaDggcS4MW0elI6BIe-KHPQABKqAorAAA',
      eid: 'e1204f2b4c5d2871b8ddb234df038fb8',
      new_eid: '6ab8ba4103977f610ca93ee60cafbcbd1a66edd277729c154ffac8f5dd768b7d',
      email_arrival_time: '2023-05-11T11:06:58',
      updated_date: '2023-07-11T16:22:36',
      current_incident_id: 21176032,
      last_sender_risk_level: 'high',
      logs: [
        {
          date: '2023-07-11T13:22:36',
          log_type: 'Reclassified as Spam',
          sender_risk_level: 'high',
          reported_by: 'IRONSCALES Community',
          action_taken: 'Move to spam',
          incident_id: 21176032,
        },
      ],
    },
  },
  {
    _index: '2023-05-31_ironstaging14_entity',
    id: 'cbcfb3b875b3a582206dd222112738123ff76e18bf5d2e1cdbd059cb18183615',
    attrs: {
      company_id: 2359,
      company_name: 'IRONSDEV',
      subject: 'Someone mentioned you in a comment',
      sender_address: 'noreply.linkedin@account-info.email',
      sender_name: 'LinkedIn',
      recipient_address: 'oleksandr@ironsdev.onmicrosoft.com',
      recipient_name: 'Oleksandr Chernihov',
      incident_type: 'Email',
      links: true,
      message_id: '<168552431111.10348.17825039763822006286@account-info.email>',
      office365_message_id: 'AAkALgAAAAAAHYQDEapmEc2byACqAC-EWg0AaDggcS4MW0elI6BIe-KHPQABNqggRwAA',
      eid: '7a405c8d9d8a2872c6a81ebfb7a41284',
      new_eid: 'cbcfb3b875b3a582206dd222112738123ff76e18bf5d2e1cdbd059cb18183615',
      email_arrival_time: '2023-05-31T09:11:54',
      updated_date: '2023-07-11T16:21:24',
      current_incident_id: 22024490,
      last_sender_risk_level: 'high',
      logs: [
        {
          date: '2023-07-11T13:21:24',
          log_type: 'Reclassified as Spam',
          sender_risk_level: 'high',
          themis_confidence: 0.64,
          themis_state: 'Phishing',
          reported_by: 'Impersonation Protection',
          action_taken: 'Move to spam',
          incident_id: 22024490,
        },
      ],
    },
  },
  {
    _index: '2023-05-31_ironstaging14_entity',
    id: '9a9467b3c40d1db1ca305c263f873d0368741984bc277c515e4e9d5e7263f8b0',
    attrs: {
      company_id: 2359,
      company_name: 'IRONSDEV',
      subject: 'Someone mentioned you in a comment',
      sender_address: 'noreply.linkedin@account-info.email',
      sender_name: 'LinkedIn',
      recipient_address: 'oleksandr@ironsdev.onmicrosoft.com',
      recipient_name: 'Oleksandr Chernihov',
      incident_type: 'Email',
      links: true,
      message_id: '<168552457114.10346.2263439831415363132@account-info.email>',
      office365_message_id: 'AAkALgAAAAAAHYQDEapmEc2byACqAC-EWg0AaDggcS4MW0elI6BIe-KHPQABNqgv-QAA',
      eid: 'f5088aba271c11733e4ed1f10a8d2ca6',
      new_eid: '9a9467b3c40d1db1ca305c263f873d0368741984bc277c515e4e9d5e7263f8b0',
      email_arrival_time: '2023-05-31T09:16:16',
      updated_date: '2023-07-11T16:21:24',
      current_incident_id: 22024490,
      last_sender_risk_level: 'high',
      logs: [
        {
          date: '2023-07-11T13:21:24',
          log_type: 'Reclassified as Spam',
          sender_risk_level: 'high',
          themis_confidence: 0.64,
          themis_state: 'Phishing',
          reported_by: 'Similarity Logic',
          action_taken: 'Move to spam',
          incident_id: 22024490,
        },
      ],
    },
  },
  {
    _index: '2023-07-11_ironstaging14_entity',
    id: '9a2c238abe0f3ef61eee874c895eca891896e5a9c19489a186b0fff24878a231',
    attrs: {
      company_id: 2359,
      company_name: 'IRONSDEV',
      subject: 'Your Recent Phishing Report - Status Update',
      sender_address: 'alerts@ironscales.com',
      sender_name: 'alerts@ironscales.com',
      recipient_address: 'Maxim@ironsdev.onmicrosoft.com',
      recipient_name: 'max kogan',
      incident_type: 'Email',
      message_id: '<168908139077.8956.16089836749153720657@ironscales.com>',
      office365_message_id: 'AAkALgAAAAAAHYQDEapmEc2byACqAC-EWg0A8teWOnHY2Ee0xa2pVx2TtgABgQQ6WwAA',
      eid: '9a491adb35aa032d7a036d6b9d25224a',
      new_eid: '9a2c238abe0f3ef61eee874c895eca891896e5a9c19489a186b0fff24878a231',
      email_arrival_time: '2023-07-11T13:16:35',
      updated_date: '2023-07-11T16:16:37',
      last_sender_risk_level: 'low',
      logs: [
        {
          date: '2023-07-11T13:16:37',
          log_type: 'Presumed Safe',
          sender_risk_level: 'low',
          anomaly: 'Presumed safe',
          action_taken: 'No action',
          is_original_report: true,
        },
        {
          date: '2023-07-11T16:18:25',
          log_type: 'Reclassified as Spam',
          anomaly: 'First time sender',
          action_taken: 'No action',
          is_original_report: true,
          sender_risk_level: 'high',
          themis_confidence: 0.64,
          themis_state: 'Phishing',
        },
      ],
    },
  },
  {
    _index: '2023-06-20_ironstaging14_entity',
    id: '94b1cf72b96da09ebddb4619edd2dd31a155555174bac2c114bb6bf1f19f2deb',
    attrs: {
      company_id: 2359,
      company_name: 'IRONSDEV',
      subject: 'testing testing',
      sender_address: 'mkogan@ironscales.com',
      sender_name: 'Maxim Kogan',
      recipient_address: 'Maxim@ironsdev.onmicrosoft.com',
      recipient_name: 'max kogan',
      incident_type: 'Email',
      links: true,
      attachments: true,
      message_id:
        '<PA4PR02MB819502219B3C0AC0E08D15CEA55CA@PA4PR02MB8195.eurprd02.prod.outlook.com>',
      office365_message_id:
        'AAMkADJiNWRiNGJlLTBmY2YtNGNhOS1iOGMzLWU2YzNhYzEyZjkxNgBGAAAAAABqPiENtSchQb8Z-s0sM0z9BwDy15Y6cdjYR7TFralXHZO2AAAAAAEMAADy15Y6cdjYR7TFralXHZO2AAFzSL2dAAA=',
      eid: '00c927cf1df284c2f4ed1641d78d048b',
      new_eid: '94b1cf72b96da09ebddb4619edd2dd31a155555174bac2c114bb6bf1f19f2deb',
      email_arrival_time: '2023-06-20T12:07:40',
      updated_date: '2023-07-11T16:16:30',
      last_sender_risk_level: 'low',
      logs: [
        {
          date: '2023-07-11T13:16:30',
          log_type: 'Email ignored (allow list)',
          sender_risk_level: 'low',
          reported_by: 'End User',
          report_method: 'Reporting button',
          action_taken: 'No action',
        },
      ],
    },
  },
  {
    _index: '2023-07-11_ironstaging14_entity',
    id: '34f1237531053659857aeb353653d390a7492c5b8390ec7797cbcdf05fb57faa',
    attrs: {
      company_id: 2359,
      company_name: 'IRONSDEV',
      subject: 'FW: testing testing',
      sender_address: 'Maxim@ironsdev.onmicrosoft.com',
      sender_name: 'Maxim Kogan',
      recipient_address: '911@ironsdev.onmicrosoft.com',
      recipient_name: '911',
      incident_type: 'Email',
      links: true,
      attachments: true,
      message_id:
        '<VE1PR05MB72934F7AB790D9DA0C9E307F8031A@VE1PR05MB7293.eurprd05.prod.outlook.com>',
      office365_message_id: 'AAkALgAAAAAAHYQDEapmEc2byACqAC-EWg0A_SZ7O4lz7UaQJmIPhzWZ2AACBEGs_QAA',
      eid: '28a2e6455eaa081eb27f1a0fa86c8c67',
      new_eid: '34f1237531053659857aeb353653d390a7492c5b8390ec7797cbcdf05fb57faa',
      email_arrival_time: '2023-07-11T13:14:51',
      updated_date: '2023-07-11T16:14:54',
      last_sender_risk_level: 'medium',
      logs: [
        {
          date: '2023-07-11T13:14:54',
          log_type: 'Presumed Safe',
          sender_risk_level: 'medium',
          anomaly: 'Presumed safe',
          action_taken: 'No action',
          is_original_report: true,
        },
      ],
    },
  },
  {
    _index: '2023-07-11_ironstaging14_entity',
    id: '10ae32712b56af69d2e5ccf7db74f005b6b93ad624852b5ab018506bdd287a0e',
    attrs: {
      company_id: 2359,
      company_name: 'IRONSDEV',
      subject: 'FW: Your Recent Phishing Report - Status Update',
      sender_address: 'Maxim@ironsdev.onmicrosoft.com',
      sender_name: 'Maxim Kogan',
      recipient_address: '911@ironsdev.onmicrosoft.com',
      recipient_name: '911',
      incident_type: 'Email',
      message_id:
        '<VE1PR05MB72930E662A2E598ABB589BDD8031A@VE1PR05MB7293.eurprd05.prod.outlook.com>',
      office365_message_id: 'AAkALgAAAAAAHYQDEapmEc2byACqAC-EWg0A_SZ7O4lz7UaQJmIPhzWZ2AACBEGlIAAA',
      eid: '6668de2e14f72c71f09e12a34612d7d4',
      new_eid: '10ae32712b56af69d2e5ccf7db74f005b6b93ad624852b5ab018506bdd287a0e',
      email_arrival_time: '2023-07-11T13:14:43',
      updated_date: '2023-07-11T16:14:49',
      last_sender_risk_level: 'medium',
      logs: [
        {
          date: '2023-07-11T13:14:49',
          log_type: 'Presumed Safe',
          sender_risk_level: 'medium',
          anomaly: 'Presumed safe',
          action_taken: 'No action',
          is_original_report: true,
        },
      ],
    },
  },
  {
    _index: '2023-06-19_entity',
    id: '79a8c93dc84055e32d14e72a60e9331a4d494845b2f835bcee9c1b676261d3f3',
    attrs: {
      company_id: 2359,
      company_name: 'IRONSDEV',
      subject: 'hellotestmax',
      sender_address: 'maxim.kogan.work@gmail.com',
      sender_name: 'max kogan',
      recipient_address: 'meron@ironsdev.onmicrosoft.com',
      recipient_name: 'memememron test Elkabetztest',
      incident_type: 'Email',
      message_id: '<CANdg7xCkP0NZCQGs9NYGgYFG41kd+nT=Mu+T2h63Nfh44Bdr0g@mail.gmail.com>',
      office365_message_id: 'AAkALgAAAAAAHYQDEapmEc2byACqAC-EWg0AZhs5v-n3-0_iJVsLNgWocQACjQHUHQAA',
      eid: '636938e2a36402b9e797554208a37ccf',
      new_eid: '79a8c93dc84055e32d14e72a60e9331a4d494845b2f835bcee9c1b676261d3f3',
      email_arrival_time: '2023-06-19T07:56:26',
      updated_date: '2023-06-28T14:11:07',
      current_incident_id: 22758065,
      logs: [
        {
          date: '2023-06-21T03:59:12',
          log_type: 'Suspicious email detected',
          sender_risk_level: 'high',
          themis_state: 'Spam',
          reported_by: 'Similarity Logic',
          action_taken: 'Move to spam',
          incident_id: 22758065,
        },
      ],
    },
  },
  {
    _index: '2023-06-19_entity',
    id: '9936a6072d16ee8ab54df2d7d22cb550c96fc4c92f6030d2d4e07ebd54a8dd14',
    attrs: {
      company_id: 2359,
      company_name: 'IRONSDEV',
      subject: 'testmax2',
      sender_address: 'maxim.kogan.work@gmail.com',
      sender_name: 'max kogan',
      recipient_address: 'meron@ironsdev.onmicrosoft.com',
      recipient_name: 'memememron test Elkabetztest',
      incident_type: 'Email',
      message_id: '<CANdg7xCkuPvMGr7iZzjkpP-xTnDrZDiNdQn_LurSB1pr5zWo4Q@mail.gmail.com>',
      office365_message_id: 'AAkALgAAAAAAHYQDEapmEc2byACqAC-EWg0AZhs5v-n3-0_iJVsLNgWocQACjQHKQQAA',
      eid: '1a529ffe61a52ad259a06e23d6e7f908',
      new_eid: '9936a6072d16ee8ab54df2d7d22cb550c96fc4c92f6030d2d4e07ebd54a8dd14',
      email_arrival_time: '2023-06-19T07:08:48',
      updated_date: '2023-06-28T14:11:07',
      current_incident_id: 22758065,
      logs: [
        {
          date: '2023-06-19T07:08:54',
          log_type: 'Email ignored (matching Safe incident)',
          sender_risk_level: 'high',
          reported_by: 'Similarity Logic',
          action_taken: 'No action',
          incident_id: 22486343,
        },
        {
          date: '2023-06-19T07:28:40',
          log_type: 'Suspicious email detected',
          incident_id: 22486310,
          action_taken: 'Move to spam',
          sender_risk_level: 'high',
          reported_by: 'Similarity Logic',
          themis_state: 'Spam',
        },
        {
          date: '2023-06-19T07:28:44',
          log_type: 'Email ignored (matching Safe incident)',
          incident_id: 22486343,
          action_taken: 'No action',
          sender_risk_level: 'high',
          reported_by: 'Similarity Logic',
        },
        {
          date: '2023-06-19T08:43:25',
          is_scanback_report: true,
          is_original_report: true,
          log_type: 'Reclassified as Safe',
          incident_id: 22486343,
          action_taken: 'Revert to origin',
          sender_risk_level: 'high',
          reported_by: 'Similarity Logic',
          silent_mode: true,
          visible: true,
        },
        {
          date: '2023-06-19T08:43:25',
          log_type: 'Reclassified as Safe',
          incident_id: 22486343,
          action_taken: 'Revert to origin',
          sender_risk_level: 'high',
          reported_by: 'Similarity Logic',
          visible: true,
          silent_mode: true,
        },
        {
          date: '2023-06-19T08:43:25',
          log_type: 'Reclassified as Safe',
          incident_id: 22486343,
          action_taken: 'Revert to origin',
          sender_risk_level: 'high',
          reported_by: 'Similarity Logic',
          visible: true,
          is_scanback_report: true,
        },
        {
          date: '2023-06-19T08:43:25',
          log_type: 'Reclassified as Safe',
          incident_id: 22486343,
          action_taken: 'Revert to origin',
          sender_risk_level: 'high',
          reported_by: 'Similarity Logic',
          visible: true,
        },
        {
          date: '2023-06-19T08:43:25',
          log_type: 'Reclassified as Safe',
          incident_id: 22486343,
          action_taken: 'Revert to origin',
          sender_risk_level: 'high',
          reported_by: 'Similarity Logic',
          visible: true,
        },
        {
          date: '2023-06-19T08:43:25',
          log_type: 'Reclassified as Safe',
          incident_id: 22486343,
          action_taken: 'Revert to origin',
          sender_risk_level: 'high',
          reported_by: 'Similarity Logic',
          visible: true,
        },
        {
          date: '2023-06-19T08:43:25',
          log_type: 'Reclassified as Safe',
          incident_id: 22486343,
          action_taken: 'Revert to origin',
          sender_risk_level: 'high',
          reported_by: 'Similarity Logic',
          visible: true,
        },
        {
          date: '2023-06-19T08:43:25',
          log_type: 'Reclassified as Safe',
          incident_id: 22486343,
          action_taken: 'Revert to origin',
          sender_risk_level: 'high',
          reported_by: 'Similarity Logic',
          visible: true,
        },
        {
          date: '2023-06-19T08:43:25',
          log_type: 'Reclassified as Safe',
          incident_id: 22486343,
          action_taken: 'Revert to origin',
          sender_risk_level: 'high',
          reported_by: 'Similarity Logic',
          visible: true,
        },
        {
          date: '2023-06-19T08:43:25',
          log_type: 'Reclassified as Safe',
          incident_id: 22486343,
          action_taken: 'Revert to origin',
          sender_risk_level: 'high',
          reported_by: 'Similarity Logic',
          visible: true,
        },
        {
          date: '2023-06-19T08:43:25',
          log_type: 'Reclassified as Safe',
          incident_id: 22486343,
          action_taken: 'Revert to origin',
          sender_risk_level: 'high',
          reported_by: 'Similarity Logic',
          visible: true,
        },
        {
          date: '2023-06-19T08:43:25',
          log_type: 'Reclassified as Safe',
          incident_id: 22486343,
          action_taken: 'Revert to origin',
          sender_risk_level: 'high',
          reported_by: 'Similarity Logic',
          visible: true,
        },
        {
          date: '2023-06-19T08:43:25',
          log_type: 'Reclassified as Safe',
          incident_id: 22486343,
          action_taken: 'Revert to origin',
          sender_risk_level: 'high',
          reported_by: 'Similarity Logic',
          visible: true,
        },
        {
          date: '2023-06-19T08:43:25',
          log_type: 'Reclassified as Safe',
          incident_id: 22486343,
          action_taken: 'Revert to origin',
          sender_risk_level: 'high',
          reported_by: 'Similarity Logic',
          visible: true,
        },
        {
          date: '2023-06-19T08:43:25',
          log_type: 'Reclassified as Safe',
          incident_id: 22486343,
          action_taken: 'Revert to origin',
          sender_risk_level: 'high',
          reported_by: 'Similarity Logic',
          visible: true,
        },
        {
          date: '2023-06-19T08:43:25',
          log_type: 'Reclassified as Safe',
          incident_id: 22486343,
          action_taken: 'Revert to origin',
          sender_risk_level: 'high',
          reported_by: 'Similarity Logic',
          visible: true,
        },
        {
          date: '2023-06-19T08:43:25',
          log_type: 'Reclassified as Safe',
          incident_id: 22486343,
          action_taken: 'Revert to origin',
          sender_risk_level: 'high',
          reported_by: 'Similarity Logic',
          visible: true,
        },
        {
          date: '2023-06-21T03:59:14',
          log_type: 'Suspicious email detected',
          incident_id: 22758065,
          action_taken: 'Move to spam',
          sender_risk_level: 'high',
          reported_by: 'Similarity Logic',
          themis_state: 'Spam',
        },
      ],
    },
  },
  {
    _index: '2023-06-19_entity',
    id: 'bc1b53e73c706b966741839d3ed0192cd1ad8b11758e2b3383db8032aeda043b',
    attrs: {
      company_id: 2359,
      company_name: 'IRONSDEV',
      subject: 'test max',
      sender_address: 'maxim.kogan.work@gmail.com',
      sender_name: 'max kogan',
      recipient_address: 'meron@ironsdev.onmicrosoft.com',
      recipient_name: 'memememron test Elkabetztest',
      incident_type: 'Email',
      first_reporter: 'End User',
      message_id: '<CANdg7xC5+QXQf41s=kNtPY+QZYwgSXWt8Nokr6-FTiTA7cjJxg@mail.gmail.com>',
      office365_message_id: 'AAkALgAAAAAAHYQDEapmEc2byACqAC-EWg0AZhs5v-n3-0_iJVsLNgWocQACjQG_gQAA',
      eid: '491a666fcbabfd53884a7d686d0b5517',
      new_eid: 'bc1b53e73c706b966741839d3ed0192cd1ad8b11758e2b3383db8032aeda043b',
      email_arrival_time: '2023-06-19T06:55:33',
      updated_date: '2023-06-28T14:11:07',
      current_incident_id: 22758065,
      logs: [
        {
          initiated_by: 'End User',
          date: '2023-06-19T06:57:40',
          log_type: 'Suspicious email detected',
          sender_risk_level: 'high',
          themis_state: 'Spam',
          reported_by: 'Similarity Logic',
          action_taken: 'No action',
          incident_id: 22486310,
        },
        {
          date: '2023-06-19T06:58:05',
          log_type: 'Classified as Spam',
          incident_id: 22486310,
          action_taken: 'Move to spam',
          sender_risk_level: 'high',
          reported_by: 'Similarity Logic',
          themis_state: 'Spam',
        },
        {
          date: '2023-06-19T08:49:58',
          log_type: 'Reclassified as Safe',
          incident_id: 22486310,
          action_taken: 'Revert to origin',
          sender_risk_level: 'high',
          reported_by: 'Similarity Logic',
          themis_state: 'Spam',
        },
        {
          date: '2023-06-19T13:51:58',
          log_type: 'Reclassified as Phishing',
          incident_id: 22486310,
          action_taken: 'Quarantine',
          sender_risk_level: 'high',
          reported_by: 'Similarity Logic',
          themis_state: 'Spam',
        },
        {
          date: '2023-06-19T14:29:29',
          log_type: 'Reclassified as Safe',
          incident_id: 22486343,
          action_taken: 'Revert to origin',
          sender_risk_level: 'high',
          reported_by: 'Similarity Logic',
        },
        {
          date: '2023-06-21T03:59:12',
          log_type: 'Suspicious email detected',
          incident_id: 22758065,
          action_taken: 'Move to spam',
          sender_risk_level: 'high',
          reported_by: 'Similarity Logic',
          themis_state: 'Spam',
        },
      ],
    },
  },
  {
    _index: '2023-06-04_entity',
    id: '0c2448ef4b3665a357ed47cc5e926ccb23bc86355593d35dd352d34fb6145062',
    attrs: {
      company_id: 2359,
      company_name: 'IRONSDEV',
      subject: 'Domain look-alike',
      sender_address: 'lomy@ironsdeev.onmicrosoft.com',
      sender_name: 'lomy',
      recipient_address: 'lomy@ironsdev.onmicrosoft.com',
      recipient_name: 'Lomy Ovadia',
      incident_type: 'Email',
      vip: true,
      message_id: '<692308285.0.1685877583787.JavaMail.RonenGanel@ISIL-rganel>',
      office365_message_id: 'AAkALgAAAAAAHYQDEapmEc2byACqAC-EWg0ACtkqjERCREuqYr76B-YTcwADktjnTwAA',
      eid: '17b4c8a425185c9fce89dfede9c641d9',
      new_eid: '0c2448ef4b3665a357ed47cc5e926ccb23bc86355593d35dd352d34fb6145062',
      email_arrival_time: '2023-06-04T11:19:49',
      updated_date: '2023-06-28T14:11:01',
      threat_type: ['VIP Impersonation'],
      current_incident_id: 20344940,
      logs: [
        {
          date: '2023-06-04T11:19:53',
          log_type: 'Suspicious email detected',
          sender_risk_level: 'medium',
          themis_state: 'Phishing',
          reported_by: 'Impersonation Protection',
          anomaly: 'Domain Look-Alike',
          action_taken: 'Add banner',
          incident_id: 20344940,
          threat_type: ['VIP Impersonation'],
          is_original_report: true,
        },
      ],
    },
  },
  {
    _index: '2023-06-23_ironstaging2_entity',
    id: '92a95053d925720a5e22279da54e33df0266e53e6d4e1dfddb55a1ec0eee42b6',
    attrs: {
      company_id: 7353,
      company_name: 'Culp',
      new_eid: '92a95053d925720a5e22279da54e33df0266e53e6d4e1dfddb55a1ec0eee42b6',
      subject: 'Proofpoint Encryption Registration',
      sender_address: 'proofpoint-pps@pnfp.com',
      sender_name: 'proofpoint-pps@pnfp.com',
      recipient_address: 'KHRailey@culp.com',
      recipient_name: 'Kathleen Railey',
      classification: 'Safe',
      first_reporter: 'SOC Analyst',
      incident_type: 'Email',
      vip: true,
      message_id: '<1681741068.535.1687539486104.JavaMail.pps@m0167169.ppops.net>',
      office365_message_id: 'AAkALgAAAAAAHYQDEapmEc2byACqAC-EWg0AcEVmGUPFxUmJLmbKpJDvvgADnUMMwwAA',
      eid: '48ce4da11a98356455eb80f38dd68439',
      email_arrival_time: '2023-06-23T16:58:08',
      updated_date: '2023-08-03T15:47:31',
      current_incident_id: 23853183,
      last_sender_risk_level: 'low',
      logs: [
        {
          initiated_by: 'SOC Analyst',
          date: '2023-08-03T12:47:31',
          log_type: 'Classified as Safe',
          sender_risk_level: 'low',
          themis_confidence: 0.52,
          themis_state: 'Safe',
          action_taken: 'No action',
          incident_id: 23853183,
        },
      ],
    },
  },
]

export const microsoftMockData = [
  {
    index: '2024-03-13_ironstaging2_entity',
    attrs: {
      company_id: 210032,
      company_name: 'IC284561impersonationBannersLogs',
      new_eid: 'f0291dfe-a499-47d6-81e8-27b672fb6b78',
      subject: 'subject 1',
      sender_address: 'sub_sender@qa-outgoing-domain.com',
      sender_name: 'sub_sender',
      recipient_address: 'sub_recipient@qa-outgoing-domain.com',
      recipient_name: 'sub_recipient',
      classification: 'Phishing',
      first_reporter: 'End User',
      current_anomaly: 'Domain Look-Alike',
      incident_type: 'Email',
      threat_type: ['Advance-fee Scam'],
      primary_threat_type: 'Advance-fee Scam',
      current_themis_state: 'Phishing',
      links: false,
      attachments: true,
      message_id: 'e2e4a7b2-e09f-4ddf-b9e0-fbfe938e3ea8',
      email_arrival_time: '2024-03-13T11:27:12Z',
      updated_date: '2024-03-13T11:27:12',
      current_incident_id: 123457,
      last_sender_risk_level: 'medium',
      logs: [
        {
          is_scanback_report: true,
          date: '2024-03-13T11:27:12Z',
          anomaly: 'Domain Look-Alike',
          incident_id: 123457,
          sender_risk_level: 'medium',
          silent_mode: false,
          report_method: '911 mailbox',
          action_taken: 'Quarantine',
          initiated_by: 'End User',
          is_original_report: true,
          themis_state: 'Phishing',
          themis_confidence: 0.8,
          log_type: 'Suspicious email reported',
          visible: true,
        },
      ],
      create_incident_enabled: false,
    },
    id: 'f0291dfe-a499-47d6-81e8-27b672fb6b78',
  },
  {
    index: '2024-03-13_ironstaging2_entity',
    attrs: {
      company_id: 210032,
      company_name: 'IC284561impersonationBannersLogs',
      new_eid: '893982236cbf2c83d99e44f132d8bf98a1b2e1e77d0090a993bc95392c62e49f',
      subject: 'MS Detection Subject',
      sender_address: 'ms_detection@test.com',
      sender_name: 'ms_detection',
      recipient_address: 'admin@v5r5t.onmicrosoft.com',
      classification: 'Microsoft quarantine',
      microsoft_sender_ip: '111.111.111.111',
      first_reporter: 'Microsoft detection',
      incident_type: 'Email',
      links: true,
      attachments: true,
      links_count: 1,
      attachments_count: 1,
      message_id: '0b8fc8d8-5f19-40c7-8745-1a732098672d',
      email_arrival_time: '2024-03-13T11:27:12Z',
      updated_date: '2024-03-13T11:27:12',
      logs: [
        {
          date: '2024-03-13T11:27:12Z',
          microsoft_phish_confidence_level: 'High',
          microsoft_state: 'Phish, Spam',
          silent_mode: false,
          microsoft_spam_detection_methods: 'Advanced filter',
          microsoft_sender_from_domain: 'test.com',
          action_taken: 'Microsoft quarantine',
          initiated_by: 'Microsoft detection',
          microsoft_action_policy: 'Others',
          microsoft_phish_detection_methods: 'URL detonation reputation',
          microsoft_delivery_location: 'Quarantine',
          log_type: 'Microsoft quarantine',
          microsoft_spam_confidence_level: 'Normal',
          visible: true,
          phish: {
            detection_method: ['URL detonation reputation', 'just another text'],
            confidence_level: 'Low',
          },
        },
      ],
      create_incident_enabled: false,
    },
    id: '893982236cbf2c83d99e44f132d8bf98a1b2e1e77d0090a993bc95392c62e49f',
  },
]
